import type { AppState } from '../types';
import { api } from './api-client';
import type { CtaPlacement } from './first-party-analytics';
import type { AlunarPackageId, AlunarUpgradeId } from '../types';
export async function createCheckout(state: AppState, ctaPlacement: CtaPlacement, packageId?: AlunarPackageId): Promise<string> {
  if (!state.resume_token) throw new Error('Your reading session could not be found.');
  if (packageId) {
    const result = await api<{ url: string }>('create-checkout', { package_id: packageId }, state.resume_token);
    return result.url;
  }
  const result = await api<{ url: string }>('create-checkout', { cta_placement: ctaPlacement, client_event_id: crypto.randomUUID() }, state.resume_token); return result.url;
}
export async function createUpgradeCheckout(state: AppState, upgradeId: AlunarUpgradeId): Promise<string> {
  if (!state.resume_token) throw new Error('Your reading session could not be found.');
  const result = await api<{ url: string }>('create-checkout', { upgrade_id: upgradeId }, state.resume_token);
  return result.url;
}
